import { Modal, Button } from "solid-bootstrap";
import { Link } from "@solidjs/router";
import { Show } from "solid-js";
import { describe } from "../helpers/reservationFormat";

/**
 * Modale de confirmation d'ajout en double.
 *
 * Composant présentatif : la vue parente gère son propre signal
 * `pendingDuplicate` et passe les callbacks. Aucune dépendance au store.
 */
export default (props) => {
    return (
        <Modal show={props.show} onHide={props.onCancel} centered backdrop="static" aria-labelledby="duplicate-booking-title">
            <Modal.Header closeButton>
                <Modal.Title id="duplicate-booking-title">Réservation en double</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.isAnonymous
                        ? "Attention, nous avons retrouvé une réservation avec cet email."
                        : "Attention, vous avez déjà une réservation pour ce créneau. Confirmez-vous l'ajout ?"}
                </p>
                <Show when={props.slotInfo}>
                    <p class="fw-bold mb-0">{describe(props.slotInfo)}</p>
                </Show>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onCancel}>Annuler</Button>
                <Link href="/user/orders" class="btn btn-outline-primary">Voir mes réservations</Link>
                <Button variant="primary" onClick={props.onConfirm}>Confirmer l'ajout</Button>
            </Modal.Footer>
        </Modal>
    );
};
